module.exports = __webpack_public_path__ + "static/media/demon_crossbow.463a8ac2.png";